<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ 'bikeshop.cyclist.edit_user' | translate }}
        - {{user.Name}} {{user.Surname}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span class="hubtiger-close"></span>
    </button>
</div>
<div class="tab-container">
    <p-tabMenu [model]="userTabItems" [activeItem]="activeItem"></p-tabMenu>
</div>
<div class="modal-body">
    <div *ngIf="selectedTab === 0">
        <form [formGroup]="UserForm">
            <div class="row margin-top-8">
                <div class="col-md-2 label">
                    *{{ "general.firstname" | translate }}:
                </div>
                <div class="col-md-4">
                    <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="{{ 'general.firstname' | translate }}"
                               formControlName="Name"/>
                    </div>
                </div>
                <div class="col-md-2 label">*{{ "general.surname" | translate }}:</div>
                <div class="col-md-4">
                    <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="{{ 'general.surname' | translate }}"
                               formControlName="Surname"/>
                    </div>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-2 label">*{{ "general.email" | translate }}:</div>
                <div class="col-md-4">
                    <div class="p-inputgroup">
                        <input type="text" pInputText formControlName="Email"
                               placeholder="{{ 'general.email' | translate }}"/>
                    </div>
                </div>
                <div class="col-md-2 label">
                    {{ "general.phone_number" | translate }}:
                </div>
                <div class="col-md-4">
                    <div class="p-inputgroup">
                        <input type="text" pInputText formControlName="PhoneNumber"
                               placeholder="{{ 'general.phone_number' | translate }}"/>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div *ngIf="selectedTab === 1">
        <div class="note">
            {{ 'bikeshop.users.system_roles_header' | translate}}
        </div>
        <!-- <div *ngFor="let role of roles; let i = index" class="row margin-top-8">
          <div class="col-md-11 label" *ngIf="role.name!=='admin' || isCurrentUserAdmin">
            <span style="text-transform: capitalize;">{{ role.name }}: </span>{{i===0 && isTechnicianOtherStore ? ('***' +
            ('bikeshop.users.user_already_technician' | translate)) : role.description }}
          </div>
          <div class="col-md-1" *ngIf="role.name!=='admin' || isCurrentUserAdmin">
            <p-inputSwitch
              [disabled]="(i===0 && isTechnicianOtherStore) || (role.name === 'technician' && allocatedTechnicians >= techniciansAllowed && !isTechnician)"
              (ngModelChange)="modelChanged($event, i)" [(ngModel)]="UserRoles[i]"></p-inputSwitch>
          </div>
          <div class="row margin-top-16" *ngIf="allocatedTechnicians >= techniciansAllowed && !isTechnician">
            <div class="col-md-12 red bold">
              {{ 'bikeshop.users.technician_limit_reached' | translate }}
            </div>
          </div>
          <div class="row">
            <div *ngIf="error" class="col-md-12 errormessage">
              {{ errorMessage }}
            </div>
          </div>
        </div> -->

        <div class="row margin-top-8" *ngIf="allocatedTechnicians >= techniciansAllowed">
            <div class="col-md-12 red bold">
                {{ 'bikeshop.users.technician_limit_reached' | translate }}
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-11 label" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
                <span>{{ 'bikeshop.roles.technician' | translate }}
                    : </span>{{'bikeshop.roles.technician_description' | translate }}
            </div>
            <div class="col-md-1" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
                <p-inputSwitch
                        [disabled]="(allocatedTechnicians >= techniciansAllowed && (!isTechnician && !isFitter))"
                        (ngModelChange)="modelChanged($event, 'Technician')" [(ngModel)]="isTechnician"></p-inputSwitch>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-11 label" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
                <span>{{ 'bikeshop.roles.fitter' | translate }}
                    : </span>{{'bikeshop.roles.fitter_description' | translate }}
            </div>
            <div class="col-md-1" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
                <p-inputSwitch
                        [disabled]="(allocatedTechnicians >= techniciansAllowed && (!isTechnician && !isFitter))"
                        (ngModelChange)="modelChanged($event, 'Fitter')" [(ngModel)]="isFitter"></p-inputSwitch>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-11 label" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
                <span>{{ 'bikeshop.roles.admin' | translate }}
                    : </span>{{ 'bikeshop.roles.admin_description' | translate }}
            </div>
            <div class="col-md-1" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
                <p-inputSwitch (ngModelChange)="modelChanged($event, 'Admin')" [disabled]="!isCurrentUserAdmin" [(ngModel)]="isAdmin"></p-inputSwitch>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-11 label" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
                <span>{{ 'bikeshop.roles.workshop_manager' | translate }}
                    : </span>{{ 'bikeshop.roles.workshop_manager_description' | translate }}
            </div>
            <div class="col-md-1" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
                <p-inputSwitch (ngModelChange)="modelChanged($event, 'WorkshopManager')" [disabled]="isAdmin && !isCurrentUserAdmin"
                               [(ngModel)]="isWorkshopManager"></p-inputSwitch>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-11 label" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
                <span>{{ 'bikeshop.roles.service_lead' | translate }}
                    : </span>{{ 'bikeshop.roles.service_lead_description' | translate }}
            </div>
            <div class="col-md-1" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
                <p-inputSwitch (ngModelChange)="modelChanged($event, 'ServiceLead')" [disabled]="isAdmin && !isCurrentUserAdmin"
                               [(ngModel)]="isServiceLead"></p-inputSwitch>
            </div>
        </div>
        <div class="row margin-top-8" *ngIf="partner.PartnerType === 1">
            <div class="col-md-11 label" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
                <span>{{ 'bikeshop.roles.shop_ride_admin' | translate }}
                    : </span>{{ 'bikeshop.roles.shop_ride_admin_description' | translate }}
            </div>
            <div class="col-md-1" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
                <p-inputSwitch (ngModelChange)="modelChanged($event, 'ShopRideAdmin')"
                    [(ngModel)]="isShopRideAdmin"></p-inputSwitch>
            </div>
        </div>


    </div>

    <div *ngIf="selectedTab === 2">
        <app-technician-availability [user]="user" [technicianID]="technicianID"
                                     [messageService]="messageService"></app-technician-availability>
    </div>
    <div *ngIf="selectedTab === 3">
        <app-linked-service-types [user]="user" [technicianID]="technicianID"
                                  [messageService]="messageService"></app-linked-service-types>
    </div>
    <div *ngIf="selectedTab === 4">
        <app-linked-fittings [user]="user" [technicianID]="technicianID"
                             [messageService]="messageService"></app-linked-fittings>
    </div>
</div>

<div style="padding:16px" *ngIf="selectedTab === 0 || selectedTab === 1">
    <div class="row">
        <div class="col-md-3">
            <button pButton type="button" class="p-button-raised full-width alternate" *ngIf="selectedTab === 0"
                    label="{{ 'bikeshop.users.remove_user' | translate }}" (click)="unlinkUser()"
                    [disabled]="busy"></button>
        </div>
        <div class="col-md-6"></div>
        <div class="col-md-3" *ngIf="selectedTab === 0">
            <button pButton type="button" class="p-button-raised full-width" label="{{
          'bikeshop.modal.add_edit_user.user_form.update_user' | translate
        }}" [disabled]="busy" (click)="updateUser(UserForm.value)"></button>
        </div>
        <div class="col-md-3" *ngIf="selectedTab === 1">
            <button pButton type="button" class="p-button-raised full-width" label="{{
          'bikeshop.modal.add_edit_user.user_form.update_roles' | translate
        }}" [disabled]="busy" (click)="UpdateRoles()"></button>
        </div>
    </div>
    <div class="row margin-top-16" *ngIf="selectedTab === 0">
        <div class="col-md-9"></div>
        <div class="col-md-3">
            <button pButton type="button" (click)="resetPassword.toggle($event)" class="p-button-raised full-width" *ngIf="isSuperUser"
                    label="{{ 'bikeshop.modal.add_edit_user.reset_password.button.change_password' | translate }}"></button>
            <div style="position: absolute;right: 722px;margin-top: 16px;">
                <p-overlayPanel #resetPassword [dismissable]="false" [showCloseIcon]="true">
                    <app-reset-password [user]="user" [component]="resetPassword" [messageService]="messageService">
                    </app-reset-password>
                </p-overlayPanel>
            </div>
        </div>
    </div>
</div>
<p-toast position="top-center" styleClass="hubtiger-toast"></p-toast>
<p-confirmDialog key="user_key" header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
